/** Material Symbols のリガチャ。院内Windowsでも出る字形を選んである。 */
export function Icon({ name, className }: { name: string; className?: string }) {
  return (
    <span className={`icon ${className ?? ''}`.trim()} aria-hidden="true">
      {name}
    </span>
  );
}

/** ホバーで「→」に入れ替わるアイコン。 */
export function IconSwap({ name, to = 'arrow_forward' }: { name: string; to?: string }) {
  return (
    <span className="icon-swap" aria-hidden="true">
      <span className="icon">{name}</span>
      <span className="icon">{to}</span>
    </span>
  );
}
